var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-bold d-flex align-items-center justify-content-end text-nowrap",class:_vm.quantityClass},[_c('span',[_vm._v(_vm._s(_vm.sign)+" "+_vm._s(_vm.formattedAbsValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }